const icon = require('vue-svgicon');
icon.register({
    'lens-feature-uv': {
        width: 40,
        height: 40,
        viewBox: '0 0 40 40',
        data: `<path pid="0" d="M14 4v9a6 6 0 006 6v0a6 6 0 006-6V4M13 21l7 15 7-15" _stroke="#000"/>`,
    },
});
